import { render } from "./laudoClinico.vue?vue&type=template&id=02ff2f34&scoped=true"
import script from "./laudoClinico.vue?vue&type=script&lang=js"
export * from "./laudoClinico.vue?vue&type=script&lang=js"

import "./laudoClinico.vue?vue&type=style&index=0&id=02ff2f34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ff2f34"]])

export default __exports__